// Meta Pixel helper — Pixel ID: 4082854452013687
// Loads the official fbevents.js script and exposes typed helpers
// for PageView and AddToCart tracking. Safe to call before the script
// has finished loading — calls are queued by fbq itself.

const PIXEL_ID = '4082854452013687'
const SCRIPT_SRC = 'https://connect.facebook.net/en_US/fbevents.js'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export const initMetaPixel = () => {
  if (typeof window === 'undefined') return
  if (initialized) return
  initialized = true

  try {
    // Minimal fbq stub — queues calls until the real script loads
    const w = window as any
    if (!w.fbq) {
      const fbq: any = function () {
        // eslint-disable-next-line prefer-rest-params
        const args = Array.prototype.slice.call(arguments)
        if (fbq.callMethod) {
          fbq.callMethod.apply(fbq, args)
        } else {
          fbq.queue.push(args)
        }
      }
      fbq.queue = []
      fbq.loaded = true
      fbq.version = '2.0'
      fbq.push = fbq
      w.fbq = fbq
      w._fbq = fbq
    }

    // Inject the official script
    if (!document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
      const script = document.createElement('script')
      script.async = true
      script.src = SCRIPT_SRC
      document.head.appendChild(script)
    }

    w.fbq('init', PIXEL_ID)
  } catch {
    // Never let pixel errors break the page
  }
}

export const trackPageView = () => {
  if (typeof window === 'undefined') return
  try {
    ;(window as any).fbq && (window as any).fbq('track', 'PageView')
  } catch {}
}

export const trackAddToCart = (params?: {
  content_name?: string
  content_ids?: string[]
  value?: number
  currency?: string
}) => {
  if (typeof window === 'undefined') return
  try {
    ;(window as any).fbq &&
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'The Hormonal Balance Code',
        content_ids: ['hormonal-balance-code-bundle'],
        value: 27,
        currency: 'USD',
        ...params,
      })
  } catch {}
}
